import { useEffect } from "react";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import {
    useForm,
    useFetch,
    useToast,
    usePopup,
    useTheme,
    useStore,
    useGrid,
    useModal,
    useResource,
} from "@/comn/hooks";
import {
    BASE,
    APIS,
    SF_COMN_CD_M_SRCH,
    SG_COMN_CD_M,
    SF_COMN_CD_D,
    SG_COMN_CD_D,
} from "./services/OsciComnPpupService";

export const ComnCdMVldLst = (props: any) => {
    const { bsopClsfCd, comnCd, comnCdNm } = props;

    const pgeUid = "T_COMN_CD_DTL_DTL";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const { close, postMessage, getParams } = usePopup();

    const form = {
        comnCdDSrch: useForm({
            defaultSchema: SF_COMN_CD_D,
            defaultValues: { bsopClsfCd: bsopClsfCd, comnCd: comnCd, comnCdNm: comnCdNm },
        }),
    };

    const grid = {
        comnCdDLst: useGrid({
            defaultSchema: SG_COMN_CD_D,
        }),
    };

    const fetch = {
        getComnCdLst: useFetch({
            api: () => {
                return APIS.getComnCdDLst(form.comnCdDSrch.getValues());
            },
            onSuccess: () => {},
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.comnCdDSrch.handleSubmit(
                () => {
                    fetch.getComnCdLst.fetch();
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    const render = {
        grid_ComnCdLst: {
            cell: {
                comnCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <a
                            href="#!"
                            onClick={() => {
                                if (!comnUtils.isPopup()) return;

                                postMessage({ code: rowValues.comnCd, label: rowValues.comnCdNm });
                                close();
                            }}
                        >
                            {value}
                        </a>
                    );
                },
                comnCdVld: (props: any) => {
                    const { binding, rowValues, value } = props;
                    return (
                        <Button
                            type="button"
                            color="success"
                            onClick={() => {
                                modal.openModal({
                                    draggable: true,
                                    size: "sm",
                                    content: (
                                        <></>
                                        // <OSCI0105007S
                                        //     vhclMkerCd={vhclMkerCd}
                                        //     vhclMdlCd={rowValues.vhclMdlCd}
                                        //     callback={handler.onMdlModalCallback}
                                        // />
                                    ),
                                });
                            }}
                        >
                            {t("B_DTL")}
                        </Button>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
    }, []);

    return (
        <Page id={pgeUid} title={t("T_COMN_CD_DTL_DTL")}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.comnCdDSrch.schema.comnCd}></Group.Control>
                                <Group.Control {...form.comnCdDSrch.schema.bsopClsfCd}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.comnCdDSrch.schema.comnCdNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.comnCdDLst.grid}
                            data={fetch.getComnCdLst.data?.comnCdMList}
                            render={render.grid_ComnCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
